import React from "react";
import _ from 'lodash';
import { Row } from "components/shared/layout";
import Input from "components/input";
import Select from "components/select";
import styled from "styled-components";
import DatePicker from "components/date-picker";
import TextArea from "components/textarea";
// import Layout, { Header } from "../shared/card-layout";

const FieldWrapper = styled(Row)`
  padding: 10px;
`;

const approvedIndustries = [
  'Agriculture',,
  'Manufacturing',
  'Education',
  'Technology',
  'Real Estate',
  'Finance & Business',
  'Food & Beverage',
  'Retail Trade',
  'Construction',
  'Community',
  'Legal Services',
  'Health',
  'Beauty',
  'Consulting',
  'Other',
];

const QuestionGroup = styled(Row)`
  margin-bottom: 50px;
`;

const Details = () => {
  return (
    <div>
      <Row>
        <FieldWrapper xs={12}>
          <Input name="trading_name" placeholder="Trading Name" />
        </FieldWrapper>
        <FieldWrapper xs={12}>
          <Input name="company_registration_number" placeholder="Company Registration Number" />
        </FieldWrapper>
        <FieldWrapper xs={12} md={6}>
          <Select
            name="num_years_operating"
            placeholder={"Number of years in operation"}
            options={_.range(1, 21).map(num => ({ label: num, value: num }))}
          />
        </FieldWrapper>
        <FieldWrapper xs={12} md={6}>
          <Select
            name="industry"
            placeholder={"Industry"}
            options={approvedIndustries.map(str => ({ label: str, value: str }))}
          />
        </FieldWrapper>
        <FieldWrapper xs={12} md={6}>
          <DatePicker name="financial_year_ends" placeholder="Financial Year Ends" isDateRange/>
        </FieldWrapper>
        <FieldWrapper xs={12} md={6}>
          <Input name="website_url" placeholder="Website URL" />
        </FieldWrapper>
        <FieldWrapper xs={12}>
          <TextArea
            style={{ minHeight: 200 }}
            name="goods_and_services"
            placeholder="Goods and Services"
          />
        </FieldWrapper>
        <QuestionGroup xs={12}>
          <FieldWrapper xs={12} md={4}>
            <Select
              name="has_bank_account"
              placeholder={"Do you have a Business Bank Account?"}
              options={[
                {
                  label: 'Yes',
                  value: 'yes'
                },
                {
                  label: 'No',
                  value: 'no'
                }
              ]}
            />
          </FieldWrapper>
        </QuestionGroup>
        <QuestionGroup xs={12}>
          <FieldWrapper xs={12} md={4}>
            <Select
              name="has_vat_number"
              placeholder={"Do you have a VAT Registration Number?"}
              options={[
                {
                  label: 'Yes',
                  value: 'yes'
                },
                {
                  label: 'No',
                  value: 'no'
                }
              ]}
            />
          </FieldWrapper>
        </QuestionGroup>
        <QuestionGroup xs={12}>
          <FieldWrapper xs={12} md={4}>
            <Select
              name="has_BBBEE_certificate"
              placeholder={"Do you have a BBBEE Certificate?"}
              options={[
                {
                  label: 'Yes',
                  value: 'yes'
                },
                {
                  label: 'No',
                  value: 'no'
                }
              ]}
            />
          </FieldWrapper>
        </QuestionGroup>
      </Row>
    </div>
  );
};
export default Details;
